export default "__VITE_ASSET__mDBRyGvE__"